import { Component, OnDestroy, OnInit } from "@angular/core";
import { FuseConfigService } from "@fuse/services/config.service";
import { HealthEngageCommunicationService } from "../../../health-engage-communication.service";

declare global {
    interface Window {
        MobileApi: any;
    }
}

@Component({
    selector: "smart-form-collect-unavailable",
    templateUrl: "./smart-form-collect-unavailable.component.html",
})
export class SmartFormCollectUnavailableComponent implements OnInit, OnDestroy {
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _healthEngageCommunicationService: HealthEngageCommunicationService
    ) {
        this._fuseConfigService.config = {
            layout: {
                navbar: {
                    hidden: true,
                },
                toolbar: {
                    hidden: true,
                },
                footer: {
                    hidden: true,
                },
                sidepanel: {
                    hidden: true,
                },
            },
        };
    }

    ngOnInit(): void {
        this._healthEngageCommunicationService.emitChatVisibility(false);
    }

    ngOnDestroy(): void {
        this._healthEngageCommunicationService.emitChatVisibility(true);
    }

    onClose(): void {
        window.parent.postMessage(`[form] unavailable`, "*");
        window.MobileApi?.postMessage("[form] unavailable");
    }
}
